<template>
    <BreadCrumb PageTitle="Ajouter un service" />
    <AddService />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue"
    import AddService from "@/components/Service/AddService.vue";
  
    export default defineComponent({
      name: "AddServicePage",
      components: {
        BreadCrumb,
        AddService,
      },
    });
  </script>